import { observer } from 'mobx-react'
import { useChilizConfigProvider } from '../stores'
import Page from './Page'
import { Col, Divider, Row, Space, Typography } from 'antd'
import { collections } from '../stores/collections'
import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { NFTCard } from '../components/NFTCard'

const { Title } = Typography

const CollectionsPage = observer(() => {
  const cards: ReactNode[] = []
  const configProvider = useChilizConfigProvider()
  const collectionsForNetwork = collections[configProvider.getChainConfig().chainId]
  collectionsForNetwork.forEach((collection) => {
    cards.push(<Col lg={5} sm={24} xs={24} md={24} key={collection.address}>
      <Link to={`/collection/${collection.address}`}>
        <NFTCard title={collection.displayName} cover={collection.image} />
      </Link>
    </Col>)
  })
  return (
    <Page className={'pd-10'}>
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <Row>
          <Col span={24}>
            <Title style={{ fontFamily: 'PP Neue Machina', fontWeight: 400, marginBottom: 0 }} level={1}
              className="page-title">Browse Collections</Title>
            <Divider />
          </Col>
        </Row>
        <Row>
          {cards}
        </Row>
      </Space>
    </Page>
  )
})

export default CollectionsPage
